module.exports = __webpack_public_path__ + "static/media/profile-avatar.0c817080.png";